/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SkipAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SkipAction({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/SkipAction"
  
}) {
let selectedIsRequiredValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'is_required',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={onClick}
 data="selected.is_required"
 disabled={selectedIsRequiredValueData}
 alignSelf="flex-end"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Skip"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}